import { StakingContractType } from 'enums/staking-contract-type.enum';

import { FLEXIBLE_STAKE_CONTRACT_ABI } from 'constants/abi/flexible-stake-contract-abi.constant';
import { NEGATIVE_STAKE_CONTRACT_ABI } from 'constants/abi/negative-stake-contract-abi.constant';
import { PERIODICAL_STAKE_CONTRACT_ABI } from 'constants/abi/periodical-stake-contract-abi.constant';
import { STAKE_CONTRACT_ABI } from 'constants/abi/stake-contract-abi.constant';
import { VIP_STAKE_CONTRACT_ABI } from 'constants/abi/vip-stake-contract-abi.constant';
import { WHITELISTED_STAKE_CONTRACT_ABI } from 'constants/abi/whitelisted-stake-contract-abi.constant';

export const getStakingContractAbiByType = (type: StakingContractType) => {
  switch (type) {
    case StakingContractType.STANDARD:
      return STAKE_CONTRACT_ABI;
    case StakingContractType.FLEXIBLE:
      return FLEXIBLE_STAKE_CONTRACT_ABI;
    case StakingContractType.NEGATIVE:
      return NEGATIVE_STAKE_CONTRACT_ABI;
    case StakingContractType.PERIODICAL:
      return PERIODICAL_STAKE_CONTRACT_ABI;
    case StakingContractType.WHITELISTED:
      return WHITELISTED_STAKE_CONTRACT_ABI;
    case StakingContractType.VIP:
      return VIP_STAKE_CONTRACT_ABI;
    default:
      return STAKE_CONTRACT_ABI;
  }
};
